import api from '../../api';
import { TInPlayResponse, TInPlayParams } from './inPlay.types';
import { isWincore } from '@/features/betApprovals/pages/BetApprovals/tabs/Approvals';
import { getPrefixPath } from '@/common/utils';

const inPlayURL = `/${getPrefixPath(isWincore)}/trade-manager/in-play`;

export const queryInPlay = (params: TInPlayParams) =>
  api.get<TInPlayResponse>(inPlayURL, { params }).then((res) => res.data);
